import AssignmentMap from './styled';

export default AssignmentMap;
